import { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import Popover from '@mui/material/Popover';

import { ListFilterOption } from '@common/ui/ListFilters/common';
import ListFilterMultiSelect from '@common/ui/ListFilters/ListFilterMultiSelect';
import ListFilterSelectChipTrigger from '@common/ui/ListFilters/ListFilterSelectChipTrigger';

export interface ResourceTypeFilterOption {
  value: string;
  label: string;
  icon: string;
  searchHelper?: string;
}

interface ResourceTypeFilterProps {
  options: ResourceTypeFilterOption[];
  value: string[];
  onChange: (value: string[]) => void;
  loading?: boolean;
}

export default function ResourceTypeFilter({ options, value, onChange, loading }: ResourceTypeFilterProps) {
  const selectedOptions = useMemo(() => {
    const list: ListFilterOption[] = [];
    for (const option of options) {
      if (value.includes(option.value)) {
        list.push(option);
      }
    }
    return list;
  }, [options, value]);

  const handleOnSelect = (values: ListFilterOption[]) => {
    onChange(values.map((v) => v.value));
  };

  const handleOnClear = () => {
    onChange([]);
  };

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>();

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  const toggleDropdown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <ListFilterSelectChipTrigger
        active={open}
        label="Resource Type"
        value={selectedOptions}
        showFirstLabel={false}
        onClear={handleOnClear}
        onClick={toggleDropdown}
        loading={loading}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ width: 300 }}>
          <ListFilterMultiSelect
            options={options}
            value={selectedOptions}
            onSelect={handleOnSelect}
            enableSearch
            title="Select Resource Type Filter"
            loading={loading}
          />
        </Box>
      </Popover>
    </>
  );
}
